var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
import { InputErrorMessage } from '../elements/index';
class TextInput extends React.Component {
    render() {
        const _a = this.props, { className, errorMessage, hasError, value } = _a, rest = __rest(_a, ["className", "errorMessage", "hasError", "value"]);
        const input = (React.createElement("input", Object.assign({ value: value, className: classnames('TextInput__Input', { 'TextInput__Input--hasError': hasError }, className) }, rest)));
        return (React.createElement("div", { className: 'TextInput TextInput--withLabel TextInput--withError' },
            input,
            hasError && React.createElement(InputErrorMessage, null, errorMessage)));
    }
}
export default TextInput;
